<template>
  <div class="all__goods">
    <div class="content">
      <SearchNav :search="searchClass" @change="changeSearchClass" />
      <div class="all__goods__display">
        <div class="all__goods__display__search">
          <div
            @click="clickSaleSort(item.sortType)"
            class="sort__btn vertical-align pointer select"
            v-for="item in sortTypes"
            :key="item.sortType"
          >
            <span :class="{ middle: true, active__search: activeSearch == item.sortType }">
              {{ item.sortInfo }}
            </span>
            <img
              v-if="item.sortType !== 1 && item.sortType !== 4"
              class="middle sort__icon"
              :src="item.sortType == activeSearch ? upToLowActive : upToLow"
            />
            <img
              v-if="item.sortType === 4"
              class="middle sort__icon"
              :src="item.sortType == activeSearch ? lowToUpActive : lowToUp"
            />
          </div>
          <el-checkbox-group @change="changeActivityLabel" v-model="activityLabel">
            <el-checkbox
              v-for="active in searchClass.itemAggActivityLabels"
              :label="active"
              :key="active"
            ></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="all__goods__display__list">
          <template v-if="goodsList.length">
            <GoodsInfo
              mini
              class="pointer"
              v-for="goods in goodsList"
              @update-cart="$emit('update-cart')"
              :key="goods.itemCode"
              :hideIcon="false"
              :goods="goods"
              :purchaseAble="true"
              :itemStyle="itemStyle"
              :imgStyle="imgStyle"
              itemType="store"
              @click-goods="linkTo(goods.itemCode)"
            />
          </template>

          <div class="empty" v-else>
            <img class="empty__logo" src="@/assets/img/shop-empty.png" />
            <div class="empty__text">店铺努力上架中，敬请期待</div>
          </div>
        </div>
        <el-pagination
          style="text-align: right"
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNo"
          :page-size="searchParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
import SearchNav from './components/SearchNav';
import GoodsInfo from '@/components/GoodsInfo';

const upToLowActive = require('@/assets/search/up-to-low-active.png');
const upToLow = require('@/assets/search/up-to-low.png');
const lowToUpActive = require('@/assets/search/low-to-up-active.png');
const lowToUp = require('@/assets/search/low-to-up.png');

export default {
  components: { SearchNav, GoodsInfo },
  data() {
    return {
      upToLowActive,
      upToLow,
      lowToUpActive,
      lowToUp,
      firstFlag: true,
      goodsList: [],
      totalCount: 0,
      searchClass: {
        itemCategories: [],
        itemAggFactoryNames: []
      },
      // 筛选条件
      activeSearch: 1,
      // sortSale: false,
      activityLabel: [],
      // 搜索条件
      searchParams: {
        key: '',
        pageNo: 1,
        pageSize: 20,
        // 排序类型：1-综合排序，2-销量排序，3-月销店数降序
        orderType: 1,
        aggregateFlag: true,
        itemActivityLabel: this.$route.query.label || null,
        categoryCode: null,
        itemFactoryNames: null,
        itemSpecs: null,
        shopId: null
      },
      itemStyle: {
        width: '219px',
        border: '1px solid #D9D9D9',
        margin: '0 8px 16px 8px',
        marginBottom: '16px'
      },
      imgStyle: {
        width: '195px',
        height: '195px'
      },
      sortTypes: []
    };
  },
  inject: ['shopId'],
  computed: {
    // sale() {
    //   return this.sortSale ? upToLowActive : upToLow;
    // },
    searchText() {
      return this.$route.query.text || '';
    }
  },
  methods: {
    // clickSaleSort() {
    //   this.activeSearch = this.activeSearch == 'sale' ? '' : 'sale';
    //   this.sortSale = !this.sortSale;
    //   this.searchParams.orderType = this.sortSale ? 2 : 1;
    //   this.changeGetGoodsList();
    // },
    // clickDefaultort() {
    //   this.activeSearch = this.activeSearch == 'default' ? '' : 'default';
    //   this.searchParams.orderType = this.activeSearch == 'default' ? 1 : null;
    //   this.changeGetGoodsList();
    // },
    clickSaleSort(type) {
      this.activeSearch = type;
      this.searchParams.orderType = type;
      this.changeGetGoodsList();
    },
    async getList() {
      const params = {
        ...this.searchParams,
        key: this.searchText || null,
        shopId: this.shopId,
        saleOutStatus: 2, // 查询售罄状态： 0 未售罄 1售罄 2全部(未售罄+售罄) 默认 0 未售罄
      };
      const {
        data: { itemAggInfo, itemBasicInfos },
        totalRecord
      } = await api.goods.getGoodsList(params);
      this.goodsList = itemBasicInfos;
      this.totalCount = totalRecord;
      if (this.firstFlag) {
        this.searchClass = itemAggInfo;
        this.searchClass.itemAggActivityLabels = ['特价'];
      }
      this.firstFlag = false;
    },
    // 条件变更时获取新的商品列表
    changeGetGoodsList() {
      this.searchParams.pageNo = 1;
      this.getList();
    },
    handleCurrentChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.getList();
    },
    changeActivityLabel() {
      this.searchParams.itemActivityLabel = this.activityLabel.join() || null;
      this.changeGetGoodsList();
    },
    changeSearchClass({ categoryCode, itemFactoryNames }) {
      this.searchParams.categoryCode = categoryCode || null;
      this.searchParams.itemFactoryNames = itemFactoryNames || null;
      this.changeGetGoodsList();
    },
    async getSortType() {
      const { sortTypes } = await api.goods.getSearchSortType({ orderCategory: 2 });
      this.sortTypes = sortTypes;
    },
    linkTo(id) {
      this.$router.push({ path: `/goodsDetails/${id}` });
    }
  },

  created() {
    this.getList();
    this.getSortType();
  }
};
</script>

<style lang="scss" scoped>
.all__goods {
  background: #f5f5f5;

  padding-bottom: 56px;
  &__display {
    &__search {
      padding: 12px 10px;
      background: #eeeeee;
    }
    &__list {
      display: flex;
      padding: 16px 28px 0 28px;
      flex-wrap: wrap;
      margin-top: 12px;
      background: #ffffff;
      ::v-deep .drug__item + .drug__item {
        margin-left: 16px;
      }
      ::v-deep .drug__item:nth-child(5n + 1) {
        margin-left: 0;
      }
    }
    .sort {
      &__icon {
        width: 6px;
        height: 12px;
      }
      &__btn {
        margin-right: 10px;
        display: inline-block;
        height: 28px;
        padding: 7px 12px;
        font-size: 12px;
        font-weight: 400;
        color: #595959;
        line-height: 12px;
        border: 1px solid #dedede;
        background: #ffffff;
        &:hover {
          color: #1e8dff;
          border-color: #1e8dff;
        }
      }
    }
  }
  &__lise .middle {
    vertical-align: middle;
  }
  .mr8 {
    margin-right: 8px;
  }
  .active__search {
    color: #1e8dff;
  }
  ::v-deep .el-checkbox-group {
    display: inline-block;
  }
  ::v-deep .el-checkbox__label {
    font-size: 12px;
    font-weight: 400;
    color: #595959;
    line-height: 1;
  }
  .empty {
    flex: 1;
    padding-bottom: 238px;
    text-align: center;
    background: #f5f5f5;
    &__logo {
      width: 220px;
      height: 220px;
    }
    &__text {
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
    }
  }
}
</style>
